/**
 * Content hashing.
 *
 * WebCrypto is used because it exists in both Node 20 and every target browser,
 * so the same code produces the same hash on a developer machine and in the
 * demo. Hashes are always taken over *canonical content*, never raw DXF bytes —
 * see `canonicalDxf`.
 */
export async function sha256Hex(text: string): Promise<string> {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
